var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(_vm.user.user_type === 'Candidate')?[_c('CandidateReports',{attrs:{"userId":_vm.user.id}})]:[_vm._v(" Отчеты есть только у кандидатов ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }